import { IoMdArrowRoundBack, IoMdCheckmark } from "react-icons/io";
function VirtualKeyboard({ keys, onInput }) {
  let rows = [];

  const alphabetChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ.-_".split("");
  const isAlphabet = keys.every(
    (k) => typeof k === "string" && (alphabetChars.includes(k) || k === "back" || k === "ok")
  );

  if (isAlphabet) {
    for (let i = 0; i < keys.length; i += 10) {
      rows.push(keys.slice(i, i + 10));
    }
  } else {
    for (let i = 0; i < keys.length; i += 3) {
      rows.push(keys.slice(i, i + 3));
    }
  }

  return (
    <div className="w-full fixed bottom-0 left-0 bg-gray-100 p-4 flex flex-col gap-2 shadow-inner z-50">
      {rows.map((row, i) => (
        <div key={i} className="flex justify-center gap-2 flex-wrap">
          {row.map((key) => (
            <button
              key={key}
              onClick={() => onInput(key)}
              className={`flex-1 min-w-[40px] flex justify-center items-center h-14 rounded-lg shadow-md 
                ${key === "ok" ? "bg-custom_green text-white" :
                key === "back" ? "bg-red-600 text-white" :
                "bg-gray-300 text-black"} 
                text-xl font-bold transition-transform active:scale-95`}
            >
              {key === "back" ? <IoMdArrowRoundBack /> :
               key === "ok" ? <IoMdCheckmark /> :
               key}
            </button>
          ))}
        </div>
      ))}
    </div>
  );
}

export default VirtualKeyboard;
